import { Box, Paper, Typography } from "@mui/material";
import { FC, PropsWithChildren } from "react";

type ChartCardProps = {
  title: string;
  height?: number;
  isEmpty?: boolean;
};

const ChartCard: FC<PropsWithChildren<ChartCardProps>> = ({
  title,
  height = 300,
  isEmpty = false,
  children,
}): JSX.Element => {
  return (
    <Paper
      variant="outlined"
      sx={{
        padding: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <Box sx={{ width: "100%", height }}>
        {isEmpty ? (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Sem dados para o período selecionado.
            </Typography>
          </Box>
        ) : (
          children
        )}
      </Box>
    </Paper>
  );
};

export default ChartCard;
